import api from './api'

export const settingsService = {
  getSettings: async () => {
    const { data } = await api.get('/admin/settings')
    return data.data
  },

  updateSettings: async (payload) => {
    const { data } = await api.patch('/admin/settings', payload)
    return data.data
  },
}
